import { toast } from "react-hot-toast";
import { formatIDR } from "../../../utils/helpers/formatIDR";
import "./style.css";

const fallbackCopy = (value) => {
  const textarea = document.createElement("textarea");
  textarea.value = value;
  textarea.setAttribute("readonly", "");
  textarea.style.position = "fixed";
  textarea.style.opacity = "0";
  document.body.appendChild(textarea);
  textarea.select();
  const copied = document.execCommand("copy");
  textarea.remove();
  if (!copied) throw new Error("Copy failed");
};

const copyAccountNumber = async (value) => {
  try {
    if (navigator.clipboard?.writeText) {
      try {
        await navigator.clipboard.writeText(value);
      } catch (_error) {
        fallbackCopy(value);
      }
    } else {
      fallbackCopy(value);
    }
    toast.success("Nomor rekening berhasil disalin.");
  } catch (_error) {
    toast.error("Nomor rekening belum dapat disalin.");
  }
};

const TransferAccountModal = ({ total = 0, paymentAccount, loading = false }) => {
  const account = paymentAccount?.account;
  const isConfigured = Boolean(paymentAccount?.is_configured && account?.account_number);

  return (
    <div
      className="modal modal-blur fade akas-transfer-account-modal"
      id="transferAccountModal"
      tabIndex="-1"
      role="dialog"
      aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div className="modal-content">
          <header className="akas-transfer-header">
            <span className="akas-transfer-header-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                <path d="M3 21h18M5 21V10M19 21V10M3 10l9-6 9 6M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01M16 18h.01" />
              </svg>
            </span>
            <div className="flex-fill">
              <small>PEMBAYARAN TRANSFER</small>
              <h3>Transfer ke rekening toko</h3>
            </div>
            <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Tutup" />
          </header>

          <div className="modal-body akas-transfer-body">
            {loading ? (
              <div className="akas-transfer-loading">
                <span className="spinner-border text-primary" role="status" />
                <span>Memuat rekening tujuan...</span>
              </div>
            ) : isConfigured ? (
              <div className="row g-4 align-items-stretch">
                <div className="col-md-7">
                  <section className="akas-transfer-account-card">
                    <div className="akas-transfer-bank-mark" aria-hidden="true">
                      {(account.bank_name || account.name || "B").slice(0, 1).toUpperCase()}
                    </div>
                    <div className="akas-transfer-account-copy">
                      <small>REKENING TUJUAN</small>
                      <strong>{account.bank_name || account.name}</strong>
                      <div className="akas-transfer-account-number">
                        <span>{account.account_number}</span>
                        <button
                          type="button"
                          onClick={() => copyAccountNumber(String(account.account_number))}
                          aria-label="Salin nomor rekening">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                            <rect x="8" y="8" width="12" height="12" rx="2" />
                            <path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2" />
                          </svg>
                          Salin
                        </button>
                      </div>
                      <p>Atas nama <b>{account.account_holder || "Belum diatur"}</b></p>
                    </div>
                  </section>
                  <div className="akas-transfer-notice">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                      <path d="M12 3l7 3v5c0 5-3 8-7 10-4-2-7-5-7-10V6l7-3z" />
                      <path d="M9 12l2 2 4-4" />
                    </svg>
                    <span>Pastikan nama pemilik dan nominal sudah benar sebelum menyelesaikan transaksi.</span>
                  </div>
                </div>

                <div className="col-md-5">
                  <section className="akas-transfer-total-card">
                    <small>TOTAL YANG DITRANSFER</small>
                    <strong>{formatIDR(total)}</strong>
                    <span>Kasir tetap dapat menyesuaikan jumlah bayar di POS.</span>
                  </section>
                  <ol className="akas-transfer-steps">
                    <li><span>1</span><p>Buka aplikasi bank pelanggan.</p></li>
                    <li><span>2</span><p>Transfer ke rekening tujuan di samping.</p></li>
                    <li><span>3</span><p>Periksa bukti transfer sebelum menyimpan transaksi.</p></li>
                  </ol>
                </div>
              </div>
            ) : (
              <div className="akas-transfer-empty">
                <span className="akas-transfer-empty-icon">!</span>
                <strong>Nomor rekening belum dikonfigurasi</strong>
                <p>{paymentAccount?.error || "Owner dapat mengisi nomor rekening pada menu Keuangan → Kas & Bank, lalu memetakan akun tersebut untuk metode Transfer."}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransferAccountModal;
